import { render, staticRenderFns } from "./timeUnitsComponent.vue?vue&type=template&id=695a79b4"
import script from "./timeUnitsComponent.vue?vue&type=script&lang=ts"
export * from "./timeUnitsComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports